export const mediaPosts = [
    {
        id: 1,
        title: "Stop Wasting Time on Repetitive Tasks: Top 10 Business Processes You Should Automate",
        excerpt:
            "Stop wasting time on repetitive tasks. From onboarding and invoicing to lead management and reporting, automation can help teams work smarter, reduce errors and focus on what matters.",
        category: "Tech & Innovation",
        date: "Sep 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/Section2 - Services.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7499009340549529600",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7499009340549529600",
        height: "700",
        tags: [
            "#BusinessAutomation",
            "#Automation",
            "#DigitalTransformation",
            "#Tedekstra",
        ],
        badge: "Latest",
    },

    {
        id: 2,
        title: "Client Feedback That Means a Lot to Us!",
        excerpt:
            "Client feedback from Michele Fitzpatrick about Tedekstra’s technology transition and ongoing development support.",
        category: "Client Success",
        date: "Sep 2026",
        readTime: "2 min read",
        mediaType: "video",
        image: "/images/bespoke.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7498637143657996288",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7498637143657996288",
        height: "700",
        tags: [
            "#ClientFeedback",
            "#SoftwareDevelopment",
            "#Technology",
            "#DigitalTransformation",
            "#ClientSuccess",
        ],
        badge: null,
    },

    {
        id: 3,
        title: "A Day of Innovation, Teamwork and Fresh Ideas!",
        excerpt:
            "Highlights from the GMIT hackathon, celebrating student talent, collaboration, problem-solving and innovation.",
        category: "Talent & Culture",
        date: "Aug 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/benefitofaugmentation.jpeg",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7496538451731881984",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7496538451731881984",
        height: "700",
        tags: [
            "#Hackathon",
            "#GMIT",
            "#Tedekstra",
            "#Innovation",
            "#Technology",
            "#StudentTalent",
            "#Teamwork",
            "#FutureTalent",
        ],
        badge: "Featured",
    },

    {
        id: 4,
        title: "Client Feedback That Means a Lot to Us!",
        excerpt:
            "Client testimonial from Rob Pullen about a new website and booking platform for an adapted bike hire service.",
        category: "Client Success",
        date: "Aug 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/managed-services.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7495455410028724224",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7495455410028724224",
        height: "700",
        tags: [
            "#ClientTestimonial",
            "#CustomerSuccess",
            "#WebDevelopment",
            "#BookingSystem",
            "#BespokeSoftware",
            "#DigitalTransformation",
            "#ClientExperience",
        ],
        badge: null,
    },

    {
        id: 5,
        title: "Technology Trends 2026: The Innovations Reshaping Business",
        excerpt:
            "Key technology trends shaping business in 2026, including AI, intelligent automation, cybersecurity and bespoke software.",
        category: "Tech & Innovation",
        date: "Aug 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/teampic.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7488911415228088323",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7488911415228088323",
        height: "700",
        tags: [
            "#TechnologyTrends2026",
            "#DigitalTransformation",
            "#AI",
            "#Automation",
            "#BusinessTechnology",
            "#Tedekstra",
        ],
        badge: "Trending",
    },

    {
        id: 6,
        title:
            "Why Digital Transformation Fails And How the Right Strategy Changes Everything",
        excerpt:
            "Why digital transformation fails when businesses buy technology before diagnosing operational problems—and why a strategy-first approach matters.",
        category: "Tech & Innovation",
        date: "Aug 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/MobileDeveloped.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7486394259684843520",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7486394259684843520",
        height: "700",
        tags: [
            "#DigitalTransformation",
            "#BusinessStrategy",
            "#Automation",
            "#TechStrategy",
        ],
        badge: null,
    },

    {
        id: 7,
        title: "Celebrating the People Behind Our Success",
        excerpt:
            "Celebrating team members reaching their first-year milestone and recognising the people behind Tedekstra’s growth.",
        category: "Talent & Culture",
        date: "Aug 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/CRM.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7484941037824700416",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7484941037824700416",
        height: "700",
        tags: [
            "#WorkAnniversary",
            "#TeamTedekstra",
            "#EmployeeRecognition",
            "#CompanyCulture",
            "#Teamwork",
            "#Growth",
        ],
        badge: null,
    },

    {
        id: 8,
        title: "Retail Automation for Operational Success",
        excerpt:
            "How automation can streamline retail operations, improve efficiency and support sustainable business growth.",
        category: "SaaS & Products",
        date: "Jul 2026",
        readTime: "3 min read",
        mediaType: "video",
        image: "/images/Container-1.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7480959161749495808",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7480959161749495808",
        height: "700",
        tags: [
            "#RetailTechnology",
            "#RetailAutomation",
            "#BusinessAutomation",
            "#DigitalTransformation",
            "#RetailOperations",
            "#BusinessGrowth",
            "#CustomSoftware",
        ],
        badge: null,
    },

    {
        id: 9,
        title: "Business Software Trends for 2026: Is Your Business Ready?",
        excerpt:
            "Three business software trends shaping 2026: AI-powered operations, connected software ecosystems and secure cloud infrastructure.",
        category: "Tech & Innovation",
        date: "Jul 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/cpc.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7478787088281366528",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7478787088281366528",
        height: "700",
        tags: [
            "#BusinessTechnology",
            "#EnterpriseSoftware",
            "#DigitalTransformation",
            "#ArtificialIntelligence",
            "#CloudComputing",
            "#BusinessAutomation",
            "#FutureOfWork",
        ],
        badge: null,
    },

    {
        id: 10,
        title: "Automate Remote Work Tracking for Clarity and Compliance",
        excerpt:
            "An intelligent digital attendance solution for real-time workforce tracking, leave management, payroll accuracy and compliance.",
        category: "SaaS & Products",
        date: "Aug 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/manageditservicecasestudy2.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7475523633847824384",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7475523633847824384",
        height: "700",
        tags: [
            "#RemoteWork",
            "#AttendanceManagement",
            "#WorkforceManagement",
            "#HRTech",
            "#BusinessAutomation",
            "#HybridWork",
            "#EmployeeManagement",
        ],
        badge: null,
    },

    {
        id: 11,
        title: "Salesforce vs. Traditional CRM: Moving Beyond the Customer Database",
        excerpt:
            "Comparing traditional CRM platforms with Salesforce and how the right CRM approach can improve visibility, processes and growth.",
        category: "SaaS & Products",
        date: "Jul 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/career_hero_bg.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7473705177993121793",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7473705177993121793",
        height: "700",
        tags: [
            "#Salesforce",
            "#CRM",
            "#CustomerRelationshipManagement",
            "#DigitalTransformation",
            "#BusinessGrowth",
            "#BusinessAutomation",
        ],
        badge: null,
    },

    {
        id: 12,
        title:
            "Optimizing Agility: The Power of End-to-End Temporary Workforce Management",
        excerpt:
            "A unified approach to temporary workforce management covering onboarding, workforce visibility, compliance, timesheets, payroll and talent.",
        category: "Talent & Culture",
        date: "Jun 2026",
        readTime: "3 min read",
        mediaType: "video",
        image: "/images/blogImage6.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7471167211303419907",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7471167211303419907",
        height: "700",
        tags: [
            "#WorkforceManagement",
            "#HRTech",
            "#TemporaryStaffing",
            "#BusinessAutomation",
            "#FutureOfWork",
        ],
        badge: null,
    },

    {
        id: 13,
        title: "Streamline HR with Tedekstra for Business Growth",
        excerpt:
            "Modern HR technology for streamlining recruitment, onboarding, administration, employee records and workforce decisions.",
        category: "Talent & Culture",
        date: "Jun 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/Group 46.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7470448431526965248",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7470448431526965248",
        height: "700",
        tags: [
            "#HRTech",
            "#HumanResources",
            "#WorkforceManagement",
            "#DigitalTransformation",
            "#EmployeeExperience",
            "#BusinessGrowth",
            "#HRTransformation",
        ],
        badge: null,
    },

    {
        id: 14,
        title: "Unlock Business Growth with Connected ERP Solutions",
        excerpt:
            "How connected ERP brings people, processes and data together to improve visibility, efficiency and decision-making.",
        category: "SaaS & Products",
        date: "Jun 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/blog19.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7470075321740939265",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7470075321740939265",
        height: "700",
        tags: [
            "#ERP",
            "#ModernERP",
            "#BusinessAutomation",
            "#DigitalTransformation",
            "#BusinessTechnology",
            "#EnterpriseSoftware",
        ],
        badge: null,
    },

    {
        id: 15,
        title: "How Technology Supports Regulatory Compliance",
        excerpt:
            "How modern compliance technology can automate processes, centralise records, reduce risk and keep businesses audit-ready.",
        category: "SaaS & Products",
        date: "Jun 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/career-group.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7468633775048953856",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7468633775048953856",
        height: "700",
        tags: [
            "#RegulatoryCompliance",
            "#BusinessAutomation",
            "#DigitalTransformation",
            "#Tedekstra",
        ],
        badge: null,
    },

    {
        id: 16,
        title: "Automation Boosts Customer Experience and Efficiency",
        excerpt:
            "How automation reduces repetitive admin, improves response times, streamlines communication and strengthens customer relationships.",
        category: "Client Success",
        date: "Jun 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/apisuccessstory.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7468267557242707969",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7468267557242707969",
        height: "700",
        tags: [
            "#CustomerExperience",
            "#BusinessAutomation",
            "#DigitalTransformation",
            "#CRM",
            "#ProcessAutomation",
        ],
        badge: null,
    },

    {
        id: 17,
        title:
            "Telecom Billing Management: Why Smarter Connected Systems Are Becoming Essential for Modern Telecom Businesses",
        excerpt:
            "Connected telecom billing systems can streamline customer records, quotations, billing, reminders and renewals.",
        category: "SaaS & Products",
        date: "Jun 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/bg-blogs.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7465742352708632576",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7465742352708632576",
        height: "700",
        tags: [
            "#Telecom",
            "#BillingManagement",
            "#DigitalTransformation",
            "#BusinessAutomation",
            "#CRM",
        ],
        badge: null,
    },

    {
        id: 18,
        title: "New Conversations. New Geographies. Bigger Vision.",
        excerpt:
            "A reflection on Tedekstra’s global expansion, relationships, networking and the people helping the business grow.",
        category: "Talent & Culture",
        date: "May 2026",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/teampic_new.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7461401630089973762",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7461401630089973762",
        height: "700",
        tags: [
            "#GlobalExpansion",
            "#Networking",
            "#Growth",
            "#Leadership",
            "#TDKGlobal",
        ],
        badge: null,
    },

    {
        id: 19,
        title: "AI Won't Replace Your Business, But Businesses Using AI Will",
        excerpt:
            "Why businesses need to adopt AI in ways that fit how they actually operate and compete.",
        category: "Tech & Innovation",
        date: "May 2026",
        readTime: "2 min read",
        mediaType: "video",
        image: "/images/Main Image.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7453410614787362819",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7453410614787362819",
        height: "700",
        tags: [
            "#AI",
            "#ArtificialIntelligence",
            "#DigitalTransformation",
            "#Automation",
            "#Tedekstra",
        ],
        badge: null,
    },

    {
        id: 20,
        title: "How Custom Software Can Turn Your Operations Into a Competitive Advantage",
        excerpt:
            "Why custom software can fit real business workflows, reduce inefficiencies and turn operations into a growth advantage.",
        category: "SaaS & Products",
        date: "Apr 2026",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/blog18.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:activity:7450874737099964416",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:activity:7450874737099964416",
        height: "700",
        tags: [
            "#CustomSoftware",
            "#DigitalTransformation",
            "#Automation",
            "#SaaS",
            "#Tedekstra",
        ],
        badge: null,
    },

    {
        id: 21,
        title: "February Is Here! Reflecting on January",
        excerpt:
            "A look back at January’s opportunities, growth and valuable business connections while looking ahead to the next chapter.",
        category: "Talent & Culture",
        date: "Feb 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/Section2 - Services.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:share:7292102301756850176",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:share:7292102301756850176",
        height: "940",
        tags: [
            "#NewMonth",
            "#Reflection",
            "#Growth",
            "#LookingAhead",
            "#Throwback",
            "#TDKGlobal",
        ],
        badge: null,
    },

    {
        id: 22,
        title: "Choosing Between Consultants and Co-Workers: What’s Best for Growth?",
        excerpt:
            "How the right mix of consultants and co-workers can support market success and sustainable business growth.",
        category: "Talent & Culture",
        date: "Sep 2025",
        readTime: "3 min read",
        mediaType: "video",
        image: "/images/bespoke.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7285205423706578944",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7285205423706578944",
        height: "640",
        tags: ["#BusinessGrowth", "#TalentStrategy", "#ThinkTDK"],
        badge: null,
    },

    {
        id: 23,
        title: "Life at TDK Global!",
        excerpt:
            "A look into the people, celebrations, workplace experiences and culture behind TDK Global.",
        category: "Talent & Culture",
        date: "Sep 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/benefitofaugmentation.jpeg",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7286909538450952192",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7286909538450952192",
        height: "900",
        tags: [
            "#LifeAtTDKGlobal",
            "#WorkplaceVibes",
            "#InnovationUnleashed",
            "#TDKGlobal",
        ],
        badge: "Spotlight",
    },

    {
        id: 24,
        title: "Happy Friday: Recognising Effort, Building Connections",
        excerpt:
            "A Friday message celebrating effort, workplace connections and new opportunities.",
        category: "Talent & Culture",
        date: "Nov 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/managed-services.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:share:7392456359146864640",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:share:7392456359146864640",
        height: "669",
        tags: ["#HappyFriday", "#WorkplaceCulture", "#FridayMotivation"],
        badge: null,
    },

    {
        id: 25,
        title: "A Heartfelt Message from Our CEO to Kick Off 2025",
        excerpt:
            "Deepak Keshari reflects on 2024 and welcomes 2025 with a message of innovation, kindness and connection.",
        category: "Talent & Culture",
        date: "Jan 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/teampic.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7280511147110256640",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7280511147110256640",
        height: "850",
        tags: ["#Leadership", "#NewYear2025", "#ThinkTDK", "#Inspiration"],
        badge: null,
    },

    {
        id: 26,
        title: "Unlock the Potential of Your Business with App Development",
        excerpt:
            "Custom mobile app development for Android and iOS, tailored to business needs and designed to drive engagement and growth.",
        category: "SaaS & Products",
        date: "Sep 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/MobileDeveloped.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:share:7287215270488608768",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:share:7287215270488608768",
        height: "920",
        tags: [
            "#MobileAppDevelopment",
            "#TechInnovation",
            "#DigitalSolutions",
            "#BusinessGrowth",
            "#AppDevelopment",
            "#DigitalTransformation",
        ],
        badge: null,
    },

    {
        id: 27,
        title: "Agentic AI: The Rise of Virtual Coworkers",
        excerpt:
            "Exploring how intelligent agents are reshaping the future of work.",
        category: "Tech & Innovation",
        date: "Oct 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/CRM.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7384483270983421952",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7384483270983421952",
        height: "551",
        tags: [
            "#AgenticAI",
            "#ArtificialIntelligence",
            "#FutureOfWork",
            "#AI",
        ],
        badge: null,
    },

    {
        id: 28,
        title: "Hybrid Software Models: Why the Future Isn’t Just SaaS or Bespoke",
        excerpt:
            "How hybrid software models combine the flexibility of bespoke development with the advantages of SaaS.",
        category: "SaaS & Products",
        date: "Sep 2025",
        readTime: "2 min read",
        mediaType: "video",
        image: "/images/Container-1.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7373965150246076416",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7373965150246076416",
        height: "551",
        tags: [
            "#HybridSoftware",
            "#SaaS",
            "#BespokeSoftware",
            "#DigitalTransformation",
        ],
        badge: null,
    },

    {
        id: 29,
        title: "TDK Swag Kit: A Sneak Peek",
        excerpt:
            "A behind-the-scenes look at the TDK Global swag kit and the team spirit behind the brand.",
        category: "Talent & Culture",
        date: "Sep 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/cpc.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:share:7284330615477313536",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:share:7284330615477313536",
        height: "816",
        tags: ["#TDKSwag", "#InnovationInAction", "#TDKGlobal", "#TeamSpirit"],
        badge: null,
    },

    {
        id: 30,
        title: "Talentrail: AI-Powered CRM for Recruitment",
        excerpt:
            "Introducing Talentrail, an AI-powered CRM that centralises recruitment applications, conversations and candidate data.",
        category: "SaaS & Products",
        date: "Sep 2025",
        readTime: "3 min read",
        mediaType: "image",
        image: "/images/manageditservicecasestudy2.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7283447284053245952",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7283447284053245952",
        height: "1150",
        tags: [
            "#Talentrail",
            "#RecruitmentInnovation",
            "#EfficiencyUnlocked",
            "#TDKGlobal",
        ],
        badge: null,
    },

    {
        id: 31,
        title: "How Edge Computing Is Transforming UK Businesses",
        excerpt:
            "How edge computing can reduce latency, support real-time decisions and improve speed, security and scalability.",
        category: "Tech & Innovation",
        date: "Nov 2025",
        readTime: "2 min read",
        mediaType: "image",
        image: "/images/career_hero_bg.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:share:7389195459459813377",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:share:7389195459459813377",
        height: "542",
        tags: [
            "#EdgeComputing",
            "#UKTech",
            "#InnovationInTech",
            "#DigitalTransformation",
            "#TechTrends",
            "#SmartBusiness",
        ],
        badge: null,
    },

    {
        id: 32,
        title: "5 Reasons Your Business Needs a Mobile App",
        excerpt:
            "Five reasons businesses may need a mobile app to improve engagement, visibility, customer experience and growth.",
        category: "SaaS & Products",
        date: "Sep 2025",
        readTime: "3 min read",
        mediaType: "video",
        image: "/images/blogImage6.png",
        postUrl:
            "https://www.linkedin.com/feed/update/urn:li:ugcPost:7372153953880301568",
        embedUrl:
            "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7372153953880301568",
        height: "566",
        tags: [
            "#MobileApp",
            "#AppDevelopment",
            "#DigitalTransformation",
            "#BusinessGrowth",
        ],
        badge: null,
    },
];

export const mediaCategories = [
    "All Posts",
    "Tech & Innovation",
    "SaaS & Products",
    "Talent & Culture",
    "Client Success",
];